<template>
  <section>
    <FilterCore v-if="!getIsMobile && isFilterPage" :lists="[locations]" />
    <div class="block-card-entries-container">
      <div class="block-card-entries-wrapper" v-if="entries.length >= 1" :class="{ loaded: entries.length }">
        <div v-for="(item, index) in entries" :key="`card-item-${item.id}`"
          :class="[{ 'animate--pop-in': entries.length }]" class="card-item-container"
          :style="`animation-delay: ${index * 100}ms`">
          <router-link :to="item.uri">
            <CardItem :entry="item" />
          </router-link>
        </div>
      </div>

      <div class="block-card-entries-state" v-else>
        <h3>{{ loadingText }}</h3>
      </div>

    </div>
  </section>
</template>

<script>
/* eslint-disable prettier/prettier */
import { mapGetters, mapState } from 'vuex';
import CardItem from '@/components/Card/CardItem';
import FilterCore from '@/components/Filter/FilterCore';

export default {
  name: 'BlockCardEntries',
  components: {
    CardItem,
    FilterCore
  },
  props: {
    block: [Array, Object]
  },
  data() {
    return {
      entries: null,
      isLoading: true,
      locations: {
        label: 'Location',
        items: [
          { label: 'Westminster', slug: 'westminster' },
          { label: 'Chester', slug: 'chester' },
          { label: 'Rural Communities', slug: 'rural-communities' },
          { label: 'National', slug: 'National' }
        ]
      }
    };
  },
  computed: {
    ...mapGetters([
      'getIsMobile',
      'getFilterLocation',
      'getIsFilterListLoaded'
    ]),
    ...mapState({
      filterLocation: state => state.filterLocation
    }),
    isFilterPage() {
      return this.$route.params.slug === 'impact' ? true : false;
    },
    section() {
      return this.block.section;
    },
    loadingText() {
      return this.isLoading
        ? 'Loading results...'
        : 'Sorry there are no results';
    },
    categoryEntries() {
      return this.entries.filter(entry => entry.hasCaseStudy);
    },
    restOfMobileEntries() {
      return this.entries ? this.entries.slice(4, this.entries.length) : null;
    },
    filteredList() {
      if (!this.entries) return [];

      if (this.getIsMobile) {
        return this.categoryEntries;
      }

      return this.entries.filter(entry => entry.hasCaseStudy);

      //   if (this.filterCategory === 'case-study') {
      //     const arr = [...this.entries];
      //     return arr.filter(x => x.hasCaseStudy);
      //   } else if (this.filterCategory === 'charities') {
      //     const arr = [...this.entries];
      //     return arr.filter(x => !x.hasCaseStudy);
      //   } else {
      //     return [...this.entries];
      //   }
      // }
    }
  },
  watch: {
    filterLocation() {
      this.getContent();
    }
  },
  created() {
    this.getContent();
  },
  methods: {
    applyLocationFilter(locationSlug) {
      this.location = locationSlug;
    },
    getContent() {
      this.isLoading = true;
      // set query params
      const queryParams =
        this.getFilterLocation !== undefined
          ? `?location=${this.getFilterLocation}`
          : '';
      this.$http
        .get(`/api/v1/case-studies-filter.json${queryParams}`)
        .then(response => {
          this.entries = response.data.data;
          this.isLoading = false;
          this.$store.commit('setIsFilterListLoaded', true);
        })
        .catch(error => console.error(error));
    }
  }
};
</script>

<style lang="postcss">
@import '../../styles/animate.css';

.block-card-entries {
  &-container {
    @apply max-w-max mx-auto;
    @apply py-16;

    @screen sm {
      @apply py-32;
    }
  }

  &-wrapper {
    @apply flex flex-wrap;

    .card-item-container {
      @apply opacity-0;
      @apply mb-24;

      &:last-of-type {
        @apply mb-0;
      }

      @screen sm {
        @apply mr-24;
      }

      @screen md {
        width: calc(50% - 6rem);
      }

      @screen lg {
        width: calc(33.33% - 6rem);
      }

      @screen xl {}

      @screen xxl {}

      &:last-of-type {
        @apply mr-0;
      }
    }

    &.loaded {
      .card-item {}
    }
  }

  &-rest {
    @apply py-16;

    h3 {
      @apply text-center;
      @apply leading-tight;
      @apply max-w-sm mx-auto;
      @apply mb-16;
      font-size: calc(26px + (26 - 26) * (100vw - 640px) / (1920 - 640));
    }

    ul {
      li {
        font-size: calc(16px + (16 - 16) * (100vw - 640px) / (1920 - 640));
        @apply border-b border-brand-border;
        @apply py-3;

        &:first-of-type {
          @apply pt-0;
        }

        a {
          @apply w-full;
          @apply flex items-center justify-between;
        }
      }
    }

    @screen sm {
      @apply py-32;
      @apply hidden;
    }
  }

  &-state {
    @apply py-16;

    h3 {
      @apply text-center;
      @apply leading-tight;
      @apply max-w-sm mx-auto;
      @apply mb-16;
      font-size: calc(26px + (26 - 26) * (100vw - 640px) / (1920 - 640));
    }

    ul {
      li {
        font-size: calc(16px + (16 - 16) * (100vw - 640px) / (1920 - 640));
        @apply border-b border-brand-border;
        @apply py-3;

        &:first-of-type {
          @apply pt-0;
        }

        a {
          @apply w-full;
          @apply flex items-center justify-between;
        }
      }
    }

    @screen sm {
      @apply py-32;
    }
  }
}
</style>
